import React, { useEffect, useState } from "react";
import { TutorProvider } from "../context/AiTutorContext";
import { LearnProvider } from "../context/LearnContext";
import { PracticeProvider } from "../context/PracticeContext";
import PracticeScreen from "../pages/ai-tutor/Practice/Practice";
import { useRoot } from "../context/RootContext";
import { useLocation, useLoaderData, useNavigate } from "@remix-run/react";
import { StorageService } from "../utils/StorageUtils";
import { isNotEmptyOrNull, urlString } from "../utils/common-utils";
import { getCookie, removeCookie } from "../utils/TutorConstants";

export const loader = async ({ request }) => {
  const url = new URL(request.url);
  const params = Array.from(url.searchParams.entries()).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {}
  );
  return { type: "practice", params: params };
};

export default function Practice() {
  const navigate = useNavigate();
  const {
    setSelectedIndex,
    setTaskTypeName,
    setSubTopicName,
    setTopicName,
    setSubjectName,
    setTaskCatagory,
    setIsAuthenticated,
    isStandaloneWithSubjectMapping,
    setIsRedirectedObjectInserted,
    setIsDiscussFlow,
    isStandalone
  } = useRoot();
  const location = useLocation();
  const { params } = useLoaderData();
  const {
    authId,
    idToken,
    refreshToken,
    userId,
    phoneNumber,
    firstName,
    lastName,
    registrationStatus,
    name,
    cognitoId,
    commonAuthId,
    subjectId,
    subjectMasterId,
    subjectName,
    topicId,
    topicName,
    subtopicId,
    subtopicName,
    gradeId,
    gradeName,
    taskType,
  } = params;

  const {
    selectedSubTopic,
    selectedTopic,
    unlockProps,
    subjectMasterUuid,
    topicMasterUuid,
    actualTaskType,
  } = location.state || {};

  useEffect(() => {
    setSelectedIndex(isStandaloneWithSubjectMapping ? 3 : isStandalone ? 3 : 4);
    StorageService.removeItem("subjectMasterUUid");
    StorageService.removeItem("topicMasterUUid");
    removeCookie("taskProgressId");
    if (typeof window !== "undefined") {
      window.history.replaceState(null, "", window.location.href);
    }
  }, []);

  useEffect(() => {
    setIsDiscussFlow(false);
    if (authId) {
      const userDetails = {
        accessToken: idToken,
        phoneNumber,
        refreshToken,
        registrationStatus,
        userId,
      };
      const userAdditionalDetails = {
        cognitoId,
        commonAuthId,
        firstName,
        grade: gradeId,
        grade_name: `Grade ${gradeName}`,
        lastName,
        phoneNumber,
        registrationStatus,
      };
      const redirectObject = {
        subjectId,
        subjectMasterId,
        subjectName,
        topicId,
        topicName,
        subtopicId,
        subtopicName,
      };
      setTopicName(topicName);
      setIsAuthenticated(true);
      StorageService.setItem("authToken", idToken);
      StorageService.setItem("xUserId", userId);
      StorageService.setItem("name", name);
      StorageService.setItem("taskType", Number(taskType));
      StorageService.setItem("user_details", JSON.stringify(userDetails));
      StorageService.setItem(
        "user_additional_details",
        JSON.stringify(userAdditionalDetails)
      );
      StorageService.setItem("gradeId", gradeId);
      StorageService.setItem("redirectObject", JSON.stringify(redirectObject));
      setIsRedirectedObjectInserted(true);
    }
  }, [authId]);

  return (
    <TutorProvider>
      <PracticeProvider>
        <PracticeScreen
          selectedSubTopic={selectedSubTopic}
          selectedTopic={selectedTopic}
          unlockProps={unlockProps}
          subjectMasterUuid={subjectMasterUuid}
          topicMasterUuid={topicMasterUuid}
          actualTaskType={actualTaskType}
        />
      </PracticeProvider>
    </TutorProvider>
  );
}
